import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-465c50c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "surface-card p-4 shadow-2 border-round" };
const _hoisted_2 = { class: "mb-3 flex flex-column align-items-start md:flex-row md:align-items-center md:justify-content-between" };
const _hoisted_3 = { class: "header-container mb-3 md:mb-0" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-3xl font-medium text-900 mb-3" }, "Review ACH File", -1));
const _hoisted_5 = { class: "surface-card p-4 shadow-2 border-round mb-2" };
const _hoisted_6 = { class: "mb-3 md:mb-0" };
const _hoisted_7 = { class: "text-3xl font-medium text-900 mb-3" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_9 = { class: "text-3xl font-medium text-900 mb-3" };
const _hoisted_10 = { class: "grid formgrid p-fluid" };
const _hoisted_11 = { class: "field mb-4 col-12 md:col-6" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Immediate Destination", -1));
const _hoisted_13 = { class: "field mb-4 col-12 md:col-6" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Immediate Origin", -1));
const _hoisted_15 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "File Creation Date (YYMMDD)", -1));
const _hoisted_17 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "File Creation Time (HHMM)", -1));
const _hoisted_19 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "File ID Modifier", -1));
const _hoisted_21 = { class: "field mb-4 col-12 md:col-3" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Record Size", -1));
const _hoisted_23 = { class: "field mb-4 col-12 md:col-3" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Blocking Factor", -1));
const _hoisted_25 = { class: "field mb-4 col-12 md:col-3" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Format Code", -1));
const _hoisted_27 = { class: "field mb-4 col-12 md:col-3" };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Ref Code", -1));
const _hoisted_29 = { class: "field mb-4 col-12 md:col-6" };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Immediate Destination Name", -1));
const _hoisted_31 = { class: "field mb-4 col-12 md:col-6" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Immediate Origin Name", -1));
const _hoisted_33 = { class: "surface-card p-4 shadow-2 border-round mb-2" };
const _hoisted_34 = { class: "mb-3 md:mb-0" };
const _hoisted_35 = { class: "text-3xl font-medium text-900 mb-3" };
const _hoisted_36 = { class: "grid formgrid p-fluid" };
const _hoisted_37 = { class: "field mb-4 col-12 md:col-6" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Company Name", -1));
const _hoisted_39 = { class: "field mb-4 col-12 md:col-6" };
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Company Disc. Data", -1));
const _hoisted_41 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Company ID", -1));
const _hoisted_43 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Standard Entry Cls Code", -1));
const _hoisted_45 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Company Entry Desc", -1));
const _hoisted_47 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Company Desc Date", -1));
const _hoisted_49 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Effective Entry Date", -1));
const _hoisted_51 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Settlement Date (Julian)", -1));
const _hoisted_53 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Originator Status Code", -1));
const _hoisted_55 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Origin DFI ID", -1));
const _hoisted_57 = { class: "field mb-4 col-12 md:col-4" };
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "",
    class: "font-medium text-900"
}, "Batch Number", -1));
const _hoisted_59 = { class: "surface-card p-4 shadow-2 border-round mb-2" };
const _hoisted_60 = { class: "mb-3 md:mb-0" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-3xl font-medium text-900 mb-3" }, "Entry Detail", -1));
import { ref } from 'vue';
import useMainStore from '@/store/main.store';
import useImportRecordsStore from '@/store/importRecords.store';
import { formatCurrency } from "@/helpers/formatter";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImportPreview',
    emits: ['processImportRecord'],
    setup(__props, { emit }) {
        const mainStore = useMainStore();
        const importRecordsStore = useImportRecordsStore();
        const importRecordPreview = ref();
        const importStages = [
            { "stage": "Import File", "icon": "pi pi-circle-fill", "color": "#2196F3" },
            { "stage": "Preview", "icon": "pi pi-circle-fill", "color": "#2196F3" },
            { "stage": "Finish", "icon": "pi pi-circle", "color": "#2196F3" }
        ];
        importRecordPreview.value = {
            fileHeader: importRecordsStore.$state.importPreview.fileHeader,
            batchHeader: importRecordsStore.$state.importPreview.batchHeader,
            detailRecords: importRecordsStore.$state.importPreview.detailRecords,
            fileTotal: importRecordsStore.$state.importPreview.fileTotal
        };
        const importRecord = importRecordsStore.recordToImport;
        const processImportRecord = (async () => {
            if (mainStore.isBusy)
                return;
            await importRecordsStore.importRecord(importRecord);
            emit('processImportRecord');
        });
        return (_ctx, _cache) => {
            const _component_Timeline = _resolveComponent("Timeline");
            const _component_Button = _resolveComponent("Button");
            const _component_InputText = _resolveComponent("InputText");
            const _component_Column = _resolveComponent("Column");
            const _component_DataTable = _resolveComponent("DataTable");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createVNode(_component_Timeline, {
                            value: importStages,
                            layout: "horizontal",
                            align: "center"
                        }, {
                            marker: _withCtx((slotProps) => [
                                _createElementVNode("i", {
                                    class: _normalizeClass(slotProps.item.icon),
                                    style: _normalizeStyle({ color: slotProps.item.color })
                                }, null, 6)
                            ]),
                            content: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.item.stage), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", null, [
                        _createVNode(_component_Button, {
                            label: "Cancel",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('back'))),
                            icon: "pi pi-arrow-left",
                            class: "p-button-info mr-1"
                        }),
                        _createVNode(_component_Button, {
                            label: "Begin Import",
                            onClick: processImportRecord,
                            loading: _unref(mainStore).isBusy,
                            class: "p-button-info"
                        }, null, 8, ["loading"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createTextVNode(" File Total: "),
                            _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(importRecordPreview.value?.fileTotal)), 1),
                            _hoisted_8
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createTextVNode(" File Header "),
                            _createElementVNode("small", null, "Priority Code: " + _toDisplayString(importRecordPreview.value.fileHeader.priorityCode), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _hoisted_12,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.immediateDestination,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((importRecordPreview.value.fileHeader.immediateDestination) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _hoisted_14,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.immediateOrigin,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((importRecordPreview.value.fileHeader.immediateOrigin) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.fileCreationDateYymmdd,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((importRecordPreview.value.fileHeader.fileCreationDateYymmdd) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _hoisted_18,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.fileCreationTimeHhmm,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((importRecordPreview.value.fileHeader.fileCreationTimeHhmm) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.fileIdModifier,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((importRecordPreview.value.fileHeader.fileIdModifier) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.recordSize,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((importRecordPreview.value.fileHeader.recordSize) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                                _hoisted_24,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.blockingFactor,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((importRecordPreview.value.fileHeader.blockingFactor) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.formatCode,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((importRecordPreview.value.fileHeader.formatCode) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.referenceCode,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((importRecordPreview.value.fileHeader.referenceCode) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.immediateDestinationName,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((importRecordPreview.value.fileHeader.immediateDestinationName) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.fileHeader.immediateOriginName,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((importRecordPreview.value.fileHeader.immediateOriginName) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _createTextVNode(" Batch Header "),
                            _createElementVNode("small", null, "Service Class Code: " + _toDisplayString(importRecordPreview.value.batchHeader.serviceClassCode), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                                _hoisted_38,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.companyName,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((importRecordPreview.value.batchHeader.companyName) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.companyDiscretionaryData,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((importRecordPreview.value.batchHeader.companyDiscretionaryData) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                                _hoisted_42,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.companyId,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((importRecordPreview.value.batchHeader.companyId) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                                _hoisted_44,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.standardEntryClassCode,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((importRecordPreview.value.batchHeader.standardEntryClassCode) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                                _hoisted_46,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.companyEntryDesc,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((importRecordPreview.value.batchHeader.companyEntryDesc) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                                _hoisted_48,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.companyDescDateYymmdd,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((importRecordPreview.value.batchHeader.companyDescDateYymmdd) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                                _hoisted_50,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.effectiveEntryDate,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((importRecordPreview.value.batchHeader.effectiveEntryDate) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                                _hoisted_52,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.settlementDateJulian,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((importRecordPreview.value.batchHeader.settlementDateJulian) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                                _hoisted_54,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.originatorStatusCode,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((importRecordPreview.value.batchHeader.originatorStatusCode) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                                _hoisted_56,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.originatingDfiid,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((importRecordPreview.value.batchHeader.originatingDfiid) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                                _hoisted_58,
                                _createVNode(_component_InputText, {
                                    modelValue: importRecordPreview.value.batchHeader.batchNumber,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((importRecordPreview.value.batchHeader.batchNumber) = $event)),
                                    type: "text",
                                    disabled: ""
                                }, null, 8, ["modelValue"])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _createVNode(_component_DataTable, {
                            value: importRecordPreview.value.detailRecords,
                            responsiveLayout: "scroll"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                    field: "receivingDfiid",
                                    header: "Routing Number"
                                }, {
                                    body: _withCtx((slotProps) => [
                                        _createTextVNode(_toDisplayString(slotProps.data.receivingDfiid) + _toDisplayString(slotProps.data.checkDigit), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_Column, {
                                    field: "dfiaccountNumber",
                                    header: "DF Acct #"
                                }),
                                _createVNode(_component_Column, {
                                    field: "totalAmount",
                                    header: "Amount"
                                }),
                                _createVNode(_component_Column, {
                                    field: "identificationNumber",
                                    header: "Individual ID #"
                                }),
                                _createVNode(_component_Column, {
                                    field: "individualName",
                                    header: "Name"
                                })
                            ]),
                            _: 1
                        }, 8, ["value"])
                    ])
                ])
            ]));
        };
    }
});
